import { defaultPageProps, defaultProps } from '../../../../app/browser/analyticsDefaultProperties';

const activityLocation = '<<attributes.data-track-activity-location.value>>';

export default {
  identify: {},
  page: {
    name: 'SP : My Business : Showcase Published',
    properties: {
      ...defaultPageProps,
      title: 'SP : My Business : Showcase Draft',
    },
  },
  elements: {
    'showcase-index-card-remove-button-*': {
      click: {
        name: 'Modal Fired',
        properties: {
          description: 'Remove Showcase',
          activityLocation,
          serviceProviderId: '[[serviceProviderId]]',
          ...defaultProps,
        },
      },
    },
    'remove-project-confirm-button': {
      click: {
        name: 'Item Clicked',
        properties: {
          description: 'Showcase Removed',
          activityLocation,
          serviceProviderId: '[[serviceProviderId]]',
          ...defaultProps,
        },
      },
    },
    'showcase-index-card-edit-button-*': {
      click: {
        name: 'Item Clicked',
        properties: {
          description: 'Edit Showcase',
          activityLocation,
          serviceProviderId: '[[serviceProviderId]]',
          ...defaultProps,
        },
      },
    },
    'showcase-index-card--display-button-*': {
      click: {
        name: 'Item Clicked',
        properties: {
          description: 'Display this Project clicked',
          activityLocation,
          serviceProviderId: '[[serviceProviderId]]',
          ...defaultProps,
        },
      },
    },
    'showcase-learn-more-button': {
      click: {
        name: 'Item Clicked',
        properties: {
          description: 'Upgrade',
          activityLocation,
          serviceProviderId: '[[serviceProviderId]]',
          ...defaultProps,
        },
      },
    },
  },
};




// WEBPACK FOOTER //
// ./src/modules/profile/browser/components/showcaseIndexAnalytics.js